import React from 'react'
import type { HeaderCellProps } from './types'
import type { OnChangeFunction } from '@ztechapps/webui.input'
import { CheckboxInput } from '@ztechapps/webui.input'
import merge from 'lodash/merge'
import { HeaderCell } from './HeaderCell'

export type TableHeaderCheckboxCellProps = {
  checked: boolean
  onChange: OnChangeFunction
  label?: string
  disabled?: boolean
} & Omit<HeaderCellProps, 'children'>

export const CheckboxHeaderCell = ({
  style,
  checked,
  onChange,
  label,
  disabled,
  ...rest
}: TableHeaderCheckboxCellProps) => {
  style = merge({}, { width: '10px' }, style)

  return (
    <HeaderCell style={style} {...rest}>
      <CheckboxInput onChange={onChange} checked={checked} label={label} disabled={disabled} />
    </HeaderCell>
  )
}
